import {systemVariables} from "@/config";
import default_image from '@/assets/img/default-horse.jpg';

/**
 * @typedef {Object} HorseImage
 * @property {number} id - ID dell'immagine
 * @property {number} horse_id - ID del cavallo associato
 * @property {string} url - URL dell'immagine
 * @property {string} created - Data di creazione dell'immagine
 * @property {string} modified - Data di modifica dell'immagine
 */


/**
 * Servizio per gestire le immagini dei cavalli.
 */
class HorseImagesService {
    path = `${systemVariables.apiUrl}/horse-images/get-photo`;

    constructor() {
    }

    getPath(){
        return this.path;
    }
    /**
     *
     * @param images
     * @param i
     * @returns {string}
     */
    getImage(images) {
        console.log('IMAGES', images);
        let index = 0;
        if(Array.isArray(images)){
            index = images.findIndex(item => item.is_main == 1);
        }
        let url = default_image;//da cambiare
        if (typeof images === 'object' && !Array.isArray(images)) {
            url = images.url;
        } else if (Array.isArray(images) && typeof images[index] === 'object') {
            url = images[index].url;
        }else{
            return url;
        }

        if(url instanceof File){
            return  URL.createObjectURL(url);;
        }

        return `${this.path}/${url}`;
    }

}

export const horseImagesService = new HorseImagesService();
